exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.swiper-pagination-bullet-active {\n    opacity: 1;\n    background: #00b100!important;\n}\n", "", {"version":3,"sources":["/app/components/BrandItemCarousel.vue"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,8BAA8B;CACjC","file":"BrandItemCarousel.vue","sourcesContent":["\n.swiper-pagination-bullet-active {\n    opacity: 1;\n    background: #00b100!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/app/assets","/static":"/app/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-074105ef","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./components/BrandItemCarousel.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/app/assets","/static":"/app/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-074105ef","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./components/BrandItemCarousel.vue
// module chunks = 0